import { API } from '../utils/api'

export const getEvent = (eventId: string) => {
	const fieldset = ['FORM', 'REGISTRATION']
	const fieldsetParam = fieldset.map((field) => `fieldset=${field}`).join('&')
	return API.get(`/events/${eventId}?${fieldsetParam}`).then(({ event }) => event)
}
